import { jsxs, jsx } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';
import 'react';
import SystemIcon from '../../DataDisplays/SystemIcon/SystemIcon.js';
import '../../Base/Layouts/Box/Box.js';
import '../../Base/Layouts/FullBleed/FullBleed.js';
import CountBadge from '../../DataDisplays/CountBadge/CountBadge.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const ButtonContainer = (_param)=>{
    var { rounded, size, type, variant, color, children, leadingIcon, isLeadingIconSolid = false, trailingIcon, isTrailingIconSolid = false, badgeNumber = '', className, disabled, onClick } = _param, rest = _object_without_properties(_param, [
        "rounded",
        "size",
        "type",
        "variant",
        "color",
        "children",
        "leadingIcon",
        "isLeadingIconSolid",
        "trailingIcon",
        "isTrailingIconSolid",
        "badgeNumber",
        "className",
        "disabled",
        "onClick"
    ]);
    const generateSize = ()=>{
        if (size === 'sm') return 'h-[36px] text-sm leading-6 gap-x-1';
        if (size === 'lg') return 'h-[60px] text-[20px] leading-[30px] gap-x-2';
        return 'h-[50px] text-base leading-[26px] gap-x-1.5';
    };
    const generatePadding = ()=>{
        const isSolid = variant === 'solid';
        if (size === 'sm') return isSolid ? 'px-3' : 'px-[11px]';
        if (size === 'lg') return isSolid ? 'px-6' : 'px-[23px]';
        return isSolid ? 'px-4' : 'px-[15px]';
    };
    const generateVariant = ()=>{
        if (variant === 'solid') return 'bg-primary-500 border-0 hover:bg-primary-700';
        if (variant === 'outline_filled') return 'bg-primary-10 border-primary-200 hover:border-primary-500';
        return color === 'primary' ? 'bg-w-white border-w-gray-200 hover:border-primary-500' : 'bg-w-white border-w-gray-200 hover:border-w-gray-400';
    };
    const generateTextColor = ()=>{
        if (disabled) {
            if (variant === 'solid') return 'text-w-white';
            if (variant === 'outline_filled') return 'text-primary-100';
            if (color === 'primary') return 'text-primary-100';
            if (color === 'gray') return 'text-w-gray-300';
        }
        if (variant === 'solid') return 'text-w-white';
        if (variant === 'outline_filled') return 'text-primary-500';
        return color === 'primary' ? 'text-primary-500' : 'text-w-gray-600';
    };
    const generateDisabledStyle = ()=>{
        if (variant === 'solid') return 'bg-primary-100 border-0 hover:bg-primary-100 hover:border-primary-100';
        if (variant === 'outline_filled') return 'bg-primary-10 border-primary-200 hover:border-primary-200';
        return 'bg-w-white border-w-gray-200 hover:border-w-gray-200';
    };
    return /*#__PURE__*/ jsxs("button", _object_spread_props(_object_spread({
        className: twMerge('box-border flex w-fit cursor-pointer items-center justify-center border', variant === 'outlined' && rounded ? 'rounded-full' : 'rounded-xl', generateSize(), generatePadding(), generateTextColor(), generateVariant(), disabled && 'cursor-not-allowed', disabled && generateDisabledStyle(), className),
        onClick: onClick,
        disabled: disabled,
        type: type
    }, rest), {
        children: [
            leadingIcon && /*#__PURE__*/ jsx(SystemIcon, {
                name: leadingIcon,
                solid: isLeadingIconSolid,
                testId: "design-system-button--leading-icon",
                className: twMerge('flex-shrink-0', size === 'sm' ? 'size-[14px]' : 'size-4', generateTextColor())
            }),
            children,
            trailingIcon && /*#__PURE__*/ jsx(SystemIcon, {
                name: trailingIcon,
                solid: isTrailingIconSolid,
                testId: "design-system-button--trailing-icon",
                className: twMerge('flex-shrink-0', size === 'sm' ? 'size-[14px]' : 'size-4', generateTextColor())
            }),
            badgeNumber && /*#__PURE__*/ jsx(CountBadge, {
                text: badgeNumber,
                className: "relative flex-shrink-0"
            })
        ]
    }));
};

export { ButtonContainer };
